import dayjs from "dayjs";
import type { ObjPathProxy } from "ts-object-path";
import type { MyPlannResourceDictionary } from "web_myplann/Infrastructure/Translations/ResourceDictionary";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";

type ResourceString = ObjPathProxy<MyPlannResourceDictionary, string>;

export const REMINDER_HIGHLIGHT_DURATION_MS = 2500;

export type ReminderRecurrence = "once" | "yearly" | "2y" | "4y";

export type ReminderEntry = {
	id: string;
	date: Date;
	recurrence: ReminderRecurrence;
};

export type ReminderDraft = {
	date: Date | null;
	recurrence: ReminderRecurrence;
};

export const REMINDER_RECURRENCE_OPTIONS: {
	value: ReminderRecurrence;
	label: ResourceString;
}[] = [
	{ value: "once", label: Resources.Reminder.Recurrence.once },
	{ value: "yearly", label: Resources.Reminder.Recurrence.yearly },
	{ value: "2y", label: Resources.Reminder.Recurrence.twoYears },
	{ value: "4y", label: Resources.Reminder.Recurrence.fourYears },
];

export const getReminderRecurrenceLabel = (
	recurrence: ReminderRecurrence,
): ResourceString =>
	REMINDER_RECURRENCE_OPTIONS.find((option) => option.value === recurrence)
		?.label ?? Resources.Reminder.Recurrence.once;

export type ReminderPresetKind = "1m_before" | "3m_before" | "expiry";

export type ReminderPreset = {
	kind: ReminderPresetKind;
	label: ResourceString;
	date: Date;
};

export const getReminderPresets = (expiry: Date | null): ReminderPreset[] => {
	if (!expiry || !dayjs(expiry).isValid()) return [];
	const R = Resources.Reminder.Presets;
	return [
		{
			kind: "1m_before",
			label: R.monthBefore,
			date: dayjs(expiry).subtract(1, "month").toDate(),
		},
		{
			kind: "3m_before",
			label: R.threeMonthsBefore,
			date: dayjs(expiry).subtract(3, "month").toDate(),
		},
		{ kind: "expiry", label: R.onExpiry, date: expiry },
	];
};
